import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHub32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconHub32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 7.73a1.998 1.998 0 0 0-.992-3.735A2 2 0 0 0 15 7.722v3.372a5 5 0 0 0-2.738 1.586l-2.918-1.684a2 2 0 1 0-1.001 1.731l2.92 1.685a5 5 0 0 0-.255 1.579c0 .555.09 1.089.258 1.588l-2.921 1.686a2 2 0 1 0 1 1.732l2.924-1.688A5 5 0 0 0 15 20.887v3.382a1.998 1.998 0 0 0 1.008 3.726A2 2 0 0 0 17 24.26v-3.37a5 5 0 0 0 2.748-1.582l2.924 1.687a2 2 0 1 0 3-1.73 2 2 0 0 0-2-.002l-2.921-1.686a5 5 0 0 0 .257-1.586 5 5 0 0 0-.255-1.58l2.918-1.685a2 2 0 1 0-1-1.732l-2.919 1.685A5 5 0 0 0 17 11.09zm-.992 11.259a2.999 2.999 0 1 0-3-2.998 3 3 0 0 0 3 2.998"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHub32);
